export const GENDERS = ['MALE', 'FEMALE', 'TRANSGENDER_MEN', 'TRANSGENDER_WOMAN', 'NON_BINARY', 'OTHERS', 'NOT_ANSWER']
